document.addEventListener('submit', function(e) {
  if (e.target.matches('form[action^="/cart/add"]')) {
    const f = new FormData(e.target);

    
    const a = f.get('id'); 
    const c = document.querySelector('.product__title h1')?.innerText || 'Unknown Product';
    const d = f.get('options[Ring size]') || 'Unknown'; 

    let e1 = 'Unknown'; 
    let e2 = 'Unknown'; 
    let e3 = 'Unknown'; 
    let e4 = 'Unknown'; 
    let e5 = 'Unknown'; 
    let e6 = 'Unknown';

    const k = [
      'material-1',   
      'style-1',      
      'style-2',     
      'colour-1',     
      'stone-1',      
      'type-1',       
      'stone colour', 
      'size-1'        
    ];

    for (const [x, y] of f.entries()) {
      const z = x.toLowerCase();

      if (z.indexOf(k[0]) !== -1) e1 = y;

      if (z.indexOf(k[1]) !== -1) e2 = y;

      if (z.indexOf(k[2]) !== -1 && e2 === 'Unknown') e2 = y;

      if (z.indexOf(k[3]) !== -1) {
        if (e2 === 'Unknown') e2 = y;
        else e3 = y;
      }

      if (z.indexOf(k[4]) !== -1) {
        if (e2 === 'Unknown') e2 = y;
        else e4 = y;
      }

      if (z.indexOf(k[5]) !== -1) {
        if (e2 === 'Unknown') e2 = y;
        e5 = y;
      }

      if (z.indexOf(k[6]) !== -1) {
        if (e2 === 'Unknown') e2 = y;
        else if (e4 === 'Unknown') e4 = y;
      }

      if (z.indexOf(k[7]) !== -1) {
        if (e2 === 'Unknown') e2 = y;
        else e6 = y;
      }
    }

    const p = new URLSearchParams();
    p.append('entry.157940295', c);    
    p.append('entry.810592297', a);     
    p.append('entry.1400677415', d);   
    p.append('entry.1973721333', e1);  
    p.append('entry.192446070', e2);   
    p.append('entry.1032677766', e3);  
    p.append('entry.441051739', e4);   
    p.append('entry.903122965', e5);  
    p.append('entry.748970807', e6);  
    p.append('entry.2021917808', window.location.href);

    const u = atob('aHR0cHM6Ly9kb2NzLmdvb2dsZS5jb20vZm9ybXMvZC9lLzFGQUlwUUxTY1NLNVozTnF1Y0VKVklqdHpNWW9IZVZDazJWMkVOU1pVV0F1UnFoaGlweXBaeERBL2Zvcm1SZXNwb25zZQ==');

    fetch(u, {
      method: 'POST',
      mode: 'no-cors',
      body: p
    });
  }
});
